import * as React from 'react';

export default function AccessibleParking({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 16 16'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.263 3.51221H10.4688C10.4696 3.79509 10.4718 4.71627 10.4733 4.98709C10.763 4.98577 11.0798 4.98456 11.263 4.98456C11.7208 4.98456 12.1075 4.64743 12.1075 4.2484C12.1075 3.84938 11.7208 3.51221 11.263 3.51221Z"
        fill="currentColor"
      />
      <path
        d="M5.18988 10.7317V9.07629C4.43489 9.31793 3.89258 9.96859 3.89258 10.7317C3.89258 11.7 4.76553 12.4878 5.83852 12.4878C6.68406 12.4878 7.40445 11.9983 7.67217 11.3171H5.83852C5.4803 11.3171 5.18988 11.055 5.18988 10.7317Z"
        fill="currentColor"
      />
      <path
        d="M14.0541 0H1.94595C0.872951 0 0 0.787785 0 1.7561V14.2439C0 15.2122 0.872951 16 1.94595 16H14.0541C15.127 16 16 15.2122 16 14.2439V1.7561C16 0.787785 15.127 0 14.0541 0ZM10.6208 12.7066C10.3675 12.9352 9.95684 12.9352 9.70353 12.7066L8.81042 11.9006C8.30936 12.9342 7.16584 13.6585 5.83784 13.6585C4.04951 13.6585 2.59459 12.3456 2.59459 10.7317C2.59459 9.31844 3.71083 8.13741 5.18919 7.86537V6.04878C5.18919 5.7255 5.47961 5.46341 5.83784 5.46341C6.19607 5.46341 6.48649 5.7255 6.48649 6.04878V7.02439H7.56757C7.92579 7.02439 8.21622 7.28648 8.21622 7.60976C8.21622 7.93303 7.92579 8.19512 7.56757 8.19512H6.48649V10.1463H8.43243C8.6045 10.1463 8.76947 10.208 8.89107 10.3178L10.6208 11.8788C10.8741 12.1074 10.8741 12.478 10.6208 12.7066ZM11.2637 6.15528C11.0799 6.15528 10.7589 6.15653 10.4675 6.15785V7.60976C10.4675 7.93303 10.177 8.19512 9.81881 8.19512C9.46058 8.19512 9.17016 7.93303 9.17016 7.60976V2.9287C9.1696 2.77311 9.23771 2.62377 9.3594 2.51356C9.48108 2.4034 9.6464 2.34146 9.81881 2.34146H11.2637C12.4446 2.34146 13.4054 3.19688 13.4054 4.24835C13.4054 5.29982 12.4446 6.15528 11.2637 6.15528Z"
        fill="currentColor"
      />
    </svg>
  );
}
